export default __webpack_public_path__ + "e4328dc9979412ce1ebbf83237077013.svg";